export const LOCATION_ART = {
  arkansas: {
    skyline: {
      src: '/images/city_explorer_skylines/arkansas.svg',
      alt: 'Little Rock skyline',
    },
  },
  connecticut: {
    skyline: {
      src: '/images/city_explorer_skylines/connecticut.svg',
      alt: 'Hartford skyline',
    },
    locator: {
      src: '/images/city_explorer_locators/connecticut.svg',
      alt: 'Map of the northeastern United States highlighting Connecticut',
    },
  },
  new_mexico: {
    skyline: {
      src: '/images/city_explorer_skylines/new_mexico.svg',
      alt: 'Albuquerque skyline and Sandia Mountains',
    },
    locator: {
      src: '/images/city_explorer_locators/new_mexico.svg',
      alt: 'Map of the United States highlighting New Mexico',
    },
  },
  newark: {
    skyline: {
      src: '/images/city_explorer_skylines/newark.svg',
      alt: 'Newark skyline',
    },
    locator: {
      src: '/images/city_explorer_locators/newark.svg',
      alt: 'Map of New Jersey highlighting Newark',
    },
  },
  washington: {
    skyline: {
      src: '/images/city_explorer_skylines/washington.svg',
      alt: 'Seattle skyline',
    },
    locator: {
      src: '/images/city_explorer_locators/washington.svg',
      alt: 'Map of the United States highlighting Washington',
    },
  },
};

export const skylineFor = (locationId) => LOCATION_ART[locationId]?.skyline || null;

export const locatorFor = (locationId) => LOCATION_ART[locationId]?.locator || null;
